import React from "react";
import { NavLink } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { withRouter } from "react-router";
import Badge from "react-bootstrap/Badge";

// Menu Icons
import ViewProfile from "../images/menu-icons/user.png";
import MySettings from "../images/menu-icons/settings.png";
import CreatorSettings from "../images/menu-icons/creator-settings.png";
import Performance from "../images/menu-icons/performance.png";
import Followers from "../images/menu-icons/followers.png";
import Following from "../images/menu-icons/following.png";
import MyRefferals from "../images/menu-icons/my-referrals.png";
import AddAccount from "../images/menu-icons/add-account.png";
import AddCard from "../images/menu-icons/add-card.png";
import DarkMode from "../images/menu-icons/dark-mode.png";
import LightMode from "../images/menu-icons/light-icon.png";
import HelpFaq from "../images/menu-icons/help-faqs.png";
import Logout from "../images/menu-icons/logout.png";
import { NUT_THEME_USERS, ROLES, s3Link } from "../utils/constants";
import DefaultLogo from "../images/default-avatar.jpg";
import { connect } from "react-redux";
import { setDarkmode } from "../../redux/actions";
import Icon from "./icon";
import pusher from "../utils/pusher";

// import '../../css/app.css';
import "../../../css/app.css";
import Avatar from "../common/Avatar";
import GlobalNotification from "../common/GlobalNotification";

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            totalNotif: 0,
            avatar: "",
            isCheckingAvatar: false,
            totalMessages: 0,
            darkmode: false,
            showNewWelcomeMessage: false,
            isThemeBlk: false,
        };

        this.subscribeToPusher = this.subscribeToPusher.bind(this);
        this.getNotifications = this.getNotifications.bind(this);
        this.subscribeToMessagePusher =
            this.subscribeToMessagePusher.bind(this);
        this.getMessages = this.getMessages.bind(this);
        this.handleWelcomeMessage = this.handleWelcomeMessage.bind(this);
    }

    handleNavigation(e, path) {
        e.preventDefault();
        const {
            history: { push },
        } = this.props;
        push(path);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.user !== this.props.user) {
            if (NUT_THEME_USERS.includes(this.props.user.id)) {
                this.setState({
                    darkmode: true,
                    isThemeBlk: true,
                });
            }
        }
    }

    componentDidMount() {
        this.subscribeToPusher("first");
        this.subscribeToMessagePusher();
        this.getNotifications();
        this.getMessages();

        const userInformation = JSON.parse(localStorage.getItem("user"));
        const darkmode = JSON.parse(localStorage.getItem("darkmode"));
        this.setState({
            darkmode: darkmode,
        });

        this.props.setDarkmode(darkmode);

        if (!this.state.isThemeBlk) {
            if (darkmode) {
                document.body.classList.add("darkmode");
                document.body.classList.remove("lightmode");
            } else {
                document.body.classList.add("lightmode");
                document.body.classList.remove("darkmode");
            }
        }

        if (this.state.isThemeBlk) {
            document.body.classList.add("darkmode");
            document.body.classList.remove("lightmode");
        }

        this.setState({ isCheckingAvatar: true });
        if (Object.keys(userInformation).length > 0) {
            let image = DefaultLogo;

            if (userInformation.profile_pic) {
                image = `${s3Link}/${
                    userInformation.id
                }/profile_photo.jpg?t=${new Date().valueOf()}`;
            }

            this.setState({ avatar: image });
            this.setState({ isCheckingAvatar: false });

            if ([ROLES.PU].includes(userInformation.role)) {
                const existingState =
                    userInformation.alerts &&
                    userInformation.alerts.length > 0 &&
                    userInformation.alerts[0].hasOwnProperty("welcome_message")
                        ? !userInformation.alerts[0].welcome_message
                        : false;

                this.setState({ showNewWelcomeMessage: existingState });
            }
        }

        document.addEventListener("visibilitychange", () =>
            this.onVisibilityChange()
        );
        window.addEventListener("pageshow", () => this.fetchCounters());
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (
            nextState.totalNotif === this.state.totalNotif &&
            nextState.totalMessages === this.state.totalMessages
        ) {
            // Nothing has changed, so a re-render is unnecessary
            return false;
        }

        return true;
    }

    componentWillUnmount() {
        document.removeEventListener("visibilitychange", () =>
            this.onVisibilityChange()
        );
        window.removeEventListener("pageshow", () => this.fetchCounters());
    }

    fetchCounters() {
        const baseUrl = process.env.MIX_APP_URL;
        const currentUrl = window.location.href;

        this.getNotifications();
        this.getMessages();

        if (currentUrl === `${baseUrl}/messages`) {
            window.dispatchEvent(new Event("chatmessage/fetchConvs"));
        }
    }

    onVisibilityChange() {
        if (!document.hidden) {
            this.fetchCounters();
        }
    }

    subscribeToMessagePusher() {
        const channel = pusher.subscribe(
            `private-new-message-${localStorage.getItem("loggedin_user")}`
        );
        const self = this;
        channel.bind("App\\Events\\NewMessageEvent", (d) => {
            self.getMessages();
            const activeConversation =
                this.props.convIndex !== null &&
                this.props.convIndex >= 0 &&
                this.props.convList &&
                this.props.convList.length > 0
                    ? this.props.convList[this.props.convIndex]
                    : null;
            const isNotSender =
                this.props.user && this.props.user.login !== d.senderName;
            if (
                (!activeConversation && isNotSender) ||
                (this.state.user &&
                    activeConversation &&
                    this.state.user.id != activeConversation.other_user &&
                    isNotSender) ||
                (this.props.convIndex < 0 && isNotSender) ||
                (this.props.convList &&
                    this.props.convList.length <= 0 &&
                    isNotSender)
            ) {
                const fc = d;
                window.dispatchEvent(
                    new CustomEvent("header/new-message", { detail: fc })
                );
            }
        });
    }

    subscribeToPusher() {
        const token = localStorage.getItem("loggedin_access_token");
        // suscribing to pusher channel
        Pusher.logToConsole = true;
        const pusher = new Pusher(process.env.MIX_PUSHER_APP_KEY, {
            cluster: process.env.MIX_PUSHER_APP_CLUSTER,
            authEndpoint: "/broadcasting/auth",
            encrypted: true,
            auth: {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            },
        });

        const channel = pusher.subscribe(
            `private-notifications-${localStorage.getItem("loggedin_user")}`
        );
        const self = this;
        channel.bind("App\\Events\\NotificationEvent", (d) => {
            self.getNotifications();
        });
    }

    getMessages() {
        axios
            .get("/api/messages/unread-count")
            .then((response) => {
                this.setState({ totalMessages: parseInt(response.data) });
            })
            .catch((error) => {
                console.log({ error });
            });
    }

    getNotifications() {
        axios
            .get("/api/notifications/count")
            .then((response) => {
                this.setState({ totalNotif: response.data });
            })
            .catch((error) => {
                console.log({ error });
            });
    }

    handleWelcomeMessage(e) {
        e.preventDefault();

        if (this.state.showNewWelcomeMessage) {
            axios
                .post("/api/alerts/update-welcome-messages")
                .then((response) => {
                    this.setState({ showNewWelcomeMessage: false });
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        this.handleNavigation(e, "/welcome-messages");
    }

    render() {
        const userInformation = JSON.parse(localStorage.getItem("user"));

        if (!userInformation || Object.keys(userInformation).length <= 0) {
            localStorage.clear();
            window.location = "/login";
        }

        const handleDarkMode = () => {
            if (!this.state.darkmode) {
                localStorage.setItem("darkmode", "true");
                document.body.classList.remove("lightmode");
                document.body.classList.add("darkmode");
            } else {
                localStorage.setItem("darkmode", "false");
                document.body.classList.remove("darkmode");
                document.body.classList.add("lightmode");
            }

            this.setState({
                darkmode: !this.state.darkmode,
            });

            this.props.setDarkmode(!this.state.darkmode);
        };

        const handleLogout = async (e) => {
            e.preventDefault();
            await axios.post("/api/logout").then((response) => {
                localStorage.removeItem("user");
                localStorage.removeItem("loggedin_access_token");
                localStorage.removeItem("loggedin_user");
                localStorage.removeItem("intended");
                window.location = "/login";
            });
        };

        return (
            <React.Fragment>
                <div className="main-header header-sticky logged-in">
                    <div className="container">
                        <div className="main-header-container">
                            <ul className="icon-nav">
                                <li>
                                    <NavLink
                                        to="/home"
                                        activeClassName="active"
                                    >
                                        <Icon
                                            icon={
                                                <i className="fa-regular fa-house-blank"></i>
                                            }
                                        />
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to="/my-notification"
                                        activeClassName="active"
                                    >
                                        <Icon
                                            icon={
                                                <i className="fa-regular fa-heart"></i>
                                            }
                                        />
                                    </NavLink>
                                    {this.state.totalNotif !== 0 &&
                                        !isNaN(this.state.totalNotif) && (
                                            <Badge
                                                pill
                                                bg="danger"
                                                text="light"
                                                className="header-badge"
                                            >
                                                {this.state.totalNotif}
                                            </Badge>
                                        )}
                                </li>
                                <li>
                                    <NavLink
                                        to="/create"
                                        activeClassName="active"
                                    >
                                        <Icon
                                            icon={
                                                <i className="fa-solid fa-plus"></i>
                                            }
                                        />
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to="/messages"
                                        activeClassName="active"
                                    >
                                        <Icon
                                            icon={
                                                <i className="fa-regular fa-messages"></i>
                                            }
                                        />
                                    </NavLink>
                                    {this.state.totalMessages > 0 &&
                                        !isNaN(this.state.totalMessages) && (
                                            <Badge
                                                pill
                                                bg="danger"
                                                text="light"
                                                className="header-badge"
                                            >
                                                {this.state.totalMessages}
                                            </Badge>
                                        )}
                                </li>
                                <li>
                                    <Dropdown className="ios">
                                        <Dropdown.Toggle
                                            id="dropdown-avatar"
                                            style={{
                                                border: 0,
                                                background: "none",
                                            }}
                                        >
                                            {!this.state.isCheckingAvatar && (
                                                <Avatar
                                                    id="header-avatar"
                                                    size="50"
                                                    story={false}
                                                    pu={userInformation}
                                                    blueBorder={true}
                                                />
                                            )}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu align="right">
                                            {userInformation.role ===
                                            ROLES.ADMIN ? (
                                                <Dropdown.Item
                                                    href="/administration/dashboard"
                                                    onClick={(e) =>
                                                        this.handleNavigation(
                                                            e,
                                                            "/administration/dashboard"
                                                        )
                                                    }
                                                >
                                                    <LazyLoadImage
                                                        src={MySettings}
                                                    />{" "}
                                                    Administration
                                                </Dropdown.Item>
                                            ) : (
                                                ""
                                            )}

                                            {userInformation.role ===
                                                ROLES.ADMIN && (
                                                <Dropdown.Divider />
                                            )}

                                            <Dropdown.Item
                                                href={`/${userInformation.login}`}
                                                onClick={(e) =>
                                                    this.handleNavigation(
                                                        e,
                                                        `/${userInformation.login}`
                                                    )
                                                }
                                            >
                                                <LazyLoadImage
                                                    src={ViewProfile}
                                                />{" "}
                                                View Profile
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                href="/edit-profile"
                                                onClick={(e) =>
                                                    this.handleNavigation(
                                                        e,
                                                        "/edit-profile"
                                                    )
                                                }
                                            >
                                                <LazyLoadImage
                                                    src={MySettings}
                                                />{" "}
                                                My Settings
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                href="/become-creator"
                                                onClick={(e) =>
                                                    this.handleNavigation(
                                                        e,
                                                        "/become-creator"
                                                    )
                                                }
                                            >
                                                <LazyLoadImage
                                                    src={CreatorSettings}
                                                />{" "}
                                                {userInformation.role !== 0
                                                    ? "Creator Settings"
                                                    : "Become Creator (Earn $)"}
                                            </Dropdown.Item>
                                            {[ROLES.PU, ROLES.ADMIN].includes(
                                                userInformation.role
                                            ) && (
                                                <Dropdown.Item
                                                    href="/welcome-messages"
                                                    onClick={(e) =>
                                                        this.handleWelcomeMessage(
                                                            e
                                                        )
                                                    }
                                                >
                                                    <LazyLoadImage
                                                        src={AddAccount}
                                                    />{" "}
                                                    Welcome Messages
                                                    {[
                                                        ROLES.PU,
                                                        ROLES.ADMIN,
                                                    ].includes(
                                                        userInformation.role
                                                    ) &&
                                                        this.state
                                                            .showNewWelcomeMessage && (
                                                            <span
                                                                bg="info"
                                                                text="light"
                                                                className="new-feature-badge badge badge-pill"
                                                            >
                                                                NEW
                                                            </span>
                                                        )}
                                                </Dropdown.Item>
                                            )}
                                            {([ROLES.ADMIN, ROLES.PU].includes(
                                                userInformation.role
                                            ) ||
                                                userInformation.referral1_count >
                                                    0 ||
                                                userInformation.referral2_count >
                                                    0) && (
                                                <Dropdown.Item
                                                    href="/performance"
                                                    onClick={(e) =>
                                                        this.handleNavigation(
                                                            e,
                                                            "/performance"
                                                        )
                                                    }
                                                >
                                                    <LazyLoadImage
                                                        src={Performance}
                                                    />{" "}
                                                    Performance
                                                </Dropdown.Item>
                                            )}
                                            {[ROLES.PU].includes(
                                                userInformation.role
                                            ) && (
                                                <Dropdown.Item
                                                    href="/user-lists"
                                                    onClick={(e) =>
                                                        this.handleNavigation(
                                                            e,
                                                            "/user-lists"
                                                        )
                                                    }
                                                >
                                                    <i
                                                        class="fa-sharp fa-solid fa-users-medical"
                                                        style={{
                                                            marginRight: "15px",
                                                        }}
                                                    ></i>{" "}
                                                    User Lists
                                                </Dropdown.Item>
                                            )}
                                            {userInformation.role !== 0 && (
                                                <Dropdown.Divider />
                                            )}
                                            {userInformation.role !== 0 && (
                                                <Dropdown.Item
                                                    href="/followers"
                                                    onClick={(e) =>
                                                        this.handleNavigation(
                                                            e,
                                                            "/followers"
                                                        )
                                                    }
                                                >
                                                    <LazyLoadImage
                                                        src={Followers}
                                                    />{" "}
                                                    Followers
                                                </Dropdown.Item>
                                            )}

                                            <Dropdown.Item
                                                href="/following"
                                                onClick={(e) =>
                                                    this.handleNavigation(
                                                        e,
                                                        "/following"
                                                    )
                                                }
                                            >
                                                <LazyLoadImage
                                                    src={Following}
                                                />{" "}
                                                Following
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                href="/my-referrals"
                                                onClick={(e) =>
                                                    this.handleNavigation(
                                                        e,
                                                        "/my-referrals"
                                                    )
                                                }
                                            >
                                                <LazyLoadImage
                                                    src={MyRefferals}
                                                />{" "}
                                                My Referrals
                                            </Dropdown.Item>

                                            <Dropdown.Divider />

                                            <Dropdown.Item
                                                href="/add-account"
                                                onClick={(e) =>
                                                    this.handleNavigation(
                                                        e,
                                                        "/add-account"
                                                    )
                                                }
                                            >
                                                <LazyLoadImage
                                                    src={AddAccount}
                                                />{" "}
                                                Add account (To receive $$)
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                href="/payment-details"
                                                onClick={(e) =>
                                                    this.handleNavigation(
                                                        e,
                                                        "/payment-details"
                                                    )
                                                }
                                            >
                                                <LazyLoadImage src={AddCard} />{" "}
                                                Add Card (To subscribe)
                                            </Dropdown.Item>

                                            <Dropdown.Divider />

                                            {(() => {
                                                if (
                                                    this.state.darkmode &&
                                                    !this.state.isThemeBlk
                                                ) {
                                                    return (
                                                        <Dropdown.Item
                                                            // href={window.location.href}
                                                            onClick={
                                                                handleDarkMode
                                                            }
                                                        >
                                                            <LazyLoadImage
                                                                src={LightMode}
                                                            />
                                                            <span>
                                                                {" "}
                                                                Light Mode
                                                            </span>
                                                        </Dropdown.Item>
                                                    );
                                                }
                                                if (
                                                    !this.state.darkmode &&
                                                    !this.state.isThemeBlk
                                                ) {
                                                    return (
                                                        <Dropdown.Item
                                                            // href={window.location.href}
                                                            onClick={
                                                                handleDarkMode
                                                            }
                                                        >
                                                            <LazyLoadImage
                                                                src={DarkMode}
                                                            />
                                                            <span>
                                                                {" "}
                                                                Dark Mode
                                                            </span>
                                                        </Dropdown.Item>
                                                    );
                                                }
                                            })()}
                                            <Dropdown.Item href="https://priva.uvdesk.com/en/">
                                                <LazyLoadImage src={HelpFaq} />{" "}
                                                Help & FAQs
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                href="/logout"
                                                onClick={handleLogout}
                                            >
                                                <LazyLoadImage src={Logout} />{" "}
                                                Logout
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Add */}
                {userInformation && <GlobalNotification />}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
        convIndex: state.message.convIndex,
        convList: state.message.convList,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        setDarkmode: (payload) => dispatch(setDarkmode(payload)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
